import { atom, useRecoilValue, useSetRecoilState, useResetRecoilState } from 'recoil';
import { VehiclesState, UseUpdateVehiclesState, UpdateVehiclesParams } from './vehicles.type';

export const vehiclesState = atom<VehiclesState>({
  default: {
    filterBy: '',
    from: 0,
    loadedAmount: 0,
    total: 0,
    vehicles: [],
  },
  key: 'vehiclesState',
});

export const useVehiclesState = (): VehiclesState => useRecoilValue(vehiclesState);

export const useUpdateVehiclesState = (): UseUpdateVehiclesState => {
  const setState = useSetRecoilState(vehiclesState);
  const reset = useResetRecoilState(vehiclesState);

  return {
    reset,
    updateState: (params: UpdateVehiclesParams) => setState(state => ({ ...state, ...params })),
  };
};
